import { ColumnDef } from '@tanstack/react-table';

import { UseBaseTable } from 'hooks/useBaseTable';

import { TableV8 } from 'components/common/Tables/TableV8/tableV8';

import { TreeRow } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/PivotBoard.logic';

interface Props {
    TableData: TreeRow[];
    table: UseBaseTable['table'];
    isLoading: boolean;
    tableColumns: ColumnDef<TreeRow>[];
}

export const GroupedByTable = ({ table, TableData, isLoading, tableColumns }: Props) => {
    return (
        <TableV8<TreeRow>
            data={TableData}
            columns={tableColumns}
            isLoading={isLoading}
            sorting={table.sorting}
            setSorting={table.setSorting}
            manualSorting={false}
            columnVisibility={table.columnVisibility}
            ref={table.tableRef}
        />
    );
};
